/**
 * A place as the API sends it — `{ address, latitude?, longitude? }` on a
 * booking's `destination_from`/`destination_to` and on each programme stop.
 */

/**
 * `{ lat, lon }` — the route services' shape — or null when the place has no
 * usable coordinates. 0,0 counts as missing: it is what an ungeocoded address
 * defaults to, not a pickup in the Gulf of Guinea.
 */
export const toLatLon = (point) => {
  const lat = Number(point?.latitude);
  const lon = Number(point?.longitude);
  if (point?.latitude == null || point?.longitude == null) return null;
  if (!Number.isFinite(lat) || !Number.isFinite(lon) || (!lat && !lon)) return null;
  return { lat, lon };
};

/**
 * Turn-by-turn navigation to a place. Prefers coordinates — an airport
 * terminal string sends drivers to the wrong door — and falls back to the
 * address. '' when there is neither.
 */
export const navigationUrl = (point) => {
  const base = 'https://www.google.com/maps/dir/?api=1&destination=';
  const at = toLatLon(point);
  if (at) return `${base}${at.lat},${at.lon}`;
  const address = String(point?.address || '').trim();
  return address ? `${base}${encodeURIComponent(address)}` : '';
};
